import { createInstanceNode } from "../schema/instanceNode.schema";
import { calculateNextCabinetPosition } from "./editorCabinetUtils";

function clone(value) {
  if (value === undefined || value === null) return value;

  if (typeof structuredClone === "function") {
    return structuredClone(value);
  }

  return JSON.parse(JSON.stringify(value));
}

export function createRootInstanceFromDefinition({
  definition,
  options = {},
  nodes = [],
  definitions = [],
  selectedId = null,
  projectParameters = {},
}) {
  const node = createInstanceNode();

  node.definitionId = definition.id;
  node.name = definition.name || definition.code;
  node.transform = {
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
  };
  node.parameterBindings = {};
  node.parameterOverrides = {};
  node.children = [];

  const nextPosition = calculateNextCabinetPosition({
    definition,
    overrides: options.parameterOverrides || {},
    nodes,
    definitions,
    selectedId,
  });

  node.transform.position.x = nextPosition.x;
  node.transform.position.z = nextPosition.z;

  if (String(definition.category || "") === "cabinet.box") {
    const h = Number(
      options.parameterOverrides?.height ||
        definition.defaultParameters?.height ||
        720
    );

    const floorOffset = Number(
      options.parameterOverrides?.floorOffset ||
        definition.defaultParameters?.floorOffset ||
        0
    );

    node.transform = {
      position: {
        x: nextPosition.x,
        y: h / 2 + floorOffset,
        z: nextPosition.z,
      },
      rotation: { x: 0, y: nextPosition.rotationY || 0, z: 0 },
    };
  }

  if (
    definition.code === "panel_board_generic" ||
    String(definition.name || "").toLowerCase().includes("board") ||
    String(definition.category || "").startsWith("board.")
  ) {
    node.parameterOverrides = {
      width: 900,
      height: 600,
      thickness: projectParameters.boardThickness || 18,
    };
  }

  if (options.parameterOverrides) {
    node.parameterOverrides = {
      ...(node.parameterOverrides || {}),
      ...options.parameterOverrides,
    };
  }

  if (options.transform?.position) {
    node.transform.position = {
      ...node.transform.position,
      ...options.transform.position,
    };
  }

  if (options.transform?.rotation) {
    node.transform.rotation = {
      ...node.transform.rotation,
      ...options.transform.rotation,
    };
  }

  if (options.partitions) {
    node.partitions = clone(options.partitions);
  }

  if (options.materialAssignments) {
    node.materialAssignments = clone(options.materialAssignments);
  }

  if (options.childDefinitionOverrides) {
    node.childDefinitionOverrides = clone(options.childDefinitionOverrides);
  }

  if (options.parentChildDefinitionOverrides) {
    node.parentChildDefinitionOverrides = clone(
      options.parentChildDefinitionOverrides
    );
  }

  if (options.shelfOverrides) {
    node.shelfOverrides = clone(options.shelfOverrides);
  }

  return node;
}